export default __webpack_public_path__ + "static/raghav-1b93e080b035160d0951a5786ea28fd2.jpeg";